import { ChatGrupoMensajes, ChatMensaje } from '../interfaces/chat.interface';

const MESES = [
  'enero',
  'febrero',
  'marzo',
  'abril',
  'mayo',
  'junio',
  'julio',
  'agosto',
  'septiembre',
  'octubre',
  'noviembre',
  'diciembre',
];

function pad(valor: number): string {
  return String(valor).padStart(2, '0');
}

export function chatHora(momento: Date = new Date()): string {
  return `${pad(momento.getHours())}:${pad(momento.getMinutes())}`;
}

export function chatFecha(momento: Date = new Date()): string {
  return `${pad(momento.getDate())}-${pad(momento.getMonth() + 1)}-${momento.getFullYear()}`;
}

/** DD-MM-YYYY a fecha local; null si el formato no coincide. */
export function parseChatFecha(fecha: string): Date | null {
  const partes = /^(\d{2})-(\d{2})-(\d{4})$/.exec(fecha.trim());
  if (!partes) {
    return null;
  }
  return new Date(Number(partes[3]), Number(partes[2]) - 1, Number(partes[1]));
}

/** Etiqueta del separador de dia dentro del chat. */
export function chatFechaLabel(fecha: string, hoy: Date = new Date()): string {
  const dia = parseChatFecha(fecha);
  if (!dia) {
    return fecha;
  }

  const base = new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate());
  const diferencia = Math.round((base.getTime() - dia.getTime()) / (1000 * 60 * 60 * 24));
  if (diferencia === 0) {
    return 'Hoy';
  }
  if (diferencia === 1) {
    return 'Ayer';
  }

  const anio = dia.getFullYear() === base.getFullYear() ? '' : ` de ${dia.getFullYear()}`;
  return `${dia.getDate()} de ${MESES[dia.getMonth()]}${anio}`;
}

/** Agrupa mensajes consecutivos del mismo dia conservando el orden original. */
export function agruparMensajesPorFecha(
  mensajes: ChatMensaje[],
  hoy: Date = new Date(),
): ChatGrupoMensajes[] {
  const grupos: ChatGrupoMensajes[] = [];

  for (const mensaje of mensajes) {
    const ultimo = grupos.at(-1);
    if (ultimo?.fecha === mensaje.fecha) {
      ultimo.mensajes.push(mensaje);
      continue;
    }
    grupos.push({
      fecha: mensaje.fecha,
      label: chatFechaLabel(mensaje.fecha, hoy),
      mensajes: [mensaje],
    });
  }

  return grupos;
}
